import TabsMobile from './TabsItemMobile';
import TabsDesktop from './TabsItemDesktop';
import { getPlatformComponent } from '../utils/getPlatformComponent';

export default getPlatformComponent({ mobile: TabsMobile, desktop: TabsDesktop });
